import RemoveFromCart from '~/themes/base/components/cart/RemoveFromCart'

export default {
  mixins: [RemoveFromCart],
}
